import { CitySearchResultWithCateg } from "@vahak/core/dist/custom-types/location-search";

export const PopularDest: CitySearchResultWithCateg[] = [
    { state_id: 1, state: "Maharashtra" },
    { state_id: 4, state: "Gujarat" },
    { state_id: 2, state: "Delhi" },
    { state_id: 3, state: "Karnataka" }
];
